import { Button, FormControl, FormHelperText, Grid, Tooltip, Typography } from '@material-ui/core';
import { HelpRounded } from '@material-ui/icons';
import { EditorState } from 'draft-js';
import 'draft-js-alignment-plugin/lib/plugin.css';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { LocalizationConfig } from '../../../config/app';
import { DataApi } from '../../../providers/api-provider';
import FieldNotes from './CampaignFieldNotes';
import { handleStateChangeFromProps, renderStringAsHtml, replaceAll, showError } from './helpers';
import TranslateInputSwitch from './TranslateInputSwitch';
import GlobalStore from "../../../providers/global-store-provider";

export default class TextareaInput extends React.Component {
    constructor(props) {
        super(props);
        if (props.localize) {
            const editorState = {};
            const value = {};
            LocalizationConfig.locales.forEach(function (item) {
                editorState[item.code] = EditorState.createEmpty();
                value[item.code] = '';
            });
            this.state.editorState = editorState;
            this.state.value = value;
        }
    }
    state = {
        error: '',
        value: '',
        enabled: '',
        onChange: null,
        type: 'text',
        name: '',
        title: '',
        width: 12,
        editorState: EditorState.createEmpty(),
        variant: 'standard',
        description: '',
        hidden: false,
        disabled: false,
        max: null,
        required: false,
        localize: false,
        currentLocale: LocalizationConfig.default,
        translationLoading: false,
        splitView: false,
        extraMarkup: null
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    onUploadImage = (file) => {
        return DataApi.uploadImage(file, true).then((res) => {
            return { data: { link: res.data.url } };
        });
    }
    performTranslationAction = async () => {
        this.setState({ translationLoading: true });
        try {
            const res = await DataApi.create((GlobalStore.state.auth.user.role==='student'?'':'admin')+'/utils/translate', {
                data: this.state.value[this.state.currentLocale],
            });
            this.state.onChange({
                target: {
                    type: 'textarea',
                    value: { ...this.state.value, [LocalizationConfig.default]: res.data },
                    name: this.state.name,
                }
            });
            this.setState({ translationLoading: false, currentLocale: LocalizationConfig.default });
        } catch (e) {
            showError(e);
            this.setState({ translationLoading: false });
        }
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    static getDerivedStateFromProps(nextProps, prevState) {
        if (JSON.stringify(nextProps.value) !== JSON.stringify(prevState.value)) {
            if (nextProps.localize) {
                LocalizationConfig.locales.forEach((item) => {
                    let contentState = stateFromHTML(nextProps.value[item.code] || '');
                    const oldEditorState = prevState.editorState;
                    let selectionState = nextProps.localize ? oldEditorState[item.code].getSelection() : oldEditorState.getSelection();
                    const nextOffSet = selectionState.getFocusOffset();
                    let editorState = EditorState.createWithContent(contentState);
                    const newSelection = editorState.getSelection().merge({
                        focusOffset: nextOffSet,
                        anchorOffset: nextOffSet
                    })
                    if (nextOffSet > 0) {
                        editorState = EditorState.forceSelection(editorState, newSelection);
                    }
                    prevState.editorState[item.code] = editorState;
                })

            } else {
                let contentState = stateFromHTML(nextProps.value);
                const oldEditorState = prevState.editorState;
                let selectionState = oldEditorState.getSelection();
                const nextOffSet = selectionState.getFocusOffset();
                let editorState = EditorState.createWithContent(contentState);
                const newSelection = editorState.getSelection().merge({
                    focusOffset: nextOffSet,
                    anchorOffset: nextOffSet
                })
                if (nextOffSet > 0)
                    editorState = EditorState.forceSelection(editorState, newSelection);
                prevState.editorState = editorState;
            }
        }
        return handleStateChangeFromProps(nextProps, prevState);
    }
    toggleView = () => {
        this.setState({ splitView: !this.state.splitView });
    }
    onEditorStateChange = (editorState) => {
        let html = stateToHTML(editorState.getCurrentContent());
        html = replaceAll(html, '&nbsp;', ' ');
        if (this.state.localize) {
            html = { ...this.state.value, [this.state.currentLocale]: html };
            this.setState({
                editorState: { ...this.state.editorState, [this.state.currentLocale]: editorState },
                value: html,
            });
            this.state.onChange({
                target: {
                    type: 'textarea',
                    value: html,
                    name: this.state.name,
                }
            })
        } else {
            this.state.onChange({
                target: {
                    type: 'textarea',
                    value: html,
                    name: this.state.name,
                }
            })
            this.setState({
                editorState,
                value: html,
            });

        }
    };
    onLocalizedEditorStateChange = (locale) => (editorState) => {
        this.setState({ currentLocale: locale }, () => {
            this.onEditorStateChange(editorState);
        })
    }
    changeLocale = (newLocale) => () => {
        this.setState({ currentLocale: newLocale });
    }
    render() {
        const { error, enabled, name, title, width, editorState, placeholder,
            translationLoading, description, variant, hidden, disabled, max, required,
            localize, currentLocale, value, splitView, extraMarkup } = this.state;
        if (hidden) {
            if (typeof (hidden) !== 'function' || hidden())
                return <div />
        }
        let processedValue = value;
        let processedEditorState = editorState;
        if (processedValue && localize) {
            processedValue = processedValue[currentLocale];
            processedEditorState = editorState[currentLocale];
        }
        //processedValue.split(/\b\S+\b/).length
        return (
            <Grid item xs={12} sm={width ? width : 12} data-form-element={name}>
                <FormControl margin="normal" variant={variant} fullWidth style={{ minHeight: '300px' }} error={error && enabled}>
                    {description && <Tooltip title={renderStringAsHtml(description)} style={{ alignSelf: 'flex-end' }} placement="top"><HelpRounded fontSize='small' /></Tooltip>}
                    <Typography color="textSecondary" >
                        {title}
                        {required ? ' *' : ''}
                    </Typography>
                    {description &&
                        <Typography color="textSecondary" style={{ fontSize: 13 }}>
                            {renderStringAsHtml(description)}
                        </Typography>
                    }
                    {max &&
                        <Typography color="textSecondary" style={{ fontSize: 13 }}>
                            {max} characters/{Math.round(max / 5)} words allowed  {!splitView && processedValue && '(currently ' + (replaceAll(processedEditorState.getCurrentContent().getPlainText(''), ' ', '').length) + ' characters)'}
                        </Typography>
                    }
                    {error && enabled ? <FormHelperText className="field-error">{typeof (error) === 'string' ? error : 'This field is required'}</FormHelperText> : ''}
                    {localize && <TranslateInputSwitch
                        performTranslationAction={this.performTranslationAction}
                        translationLoading={translationLoading}
                        currentLocale={currentLocale}
                        changeLocale={this.changeLocale}
                        value={processedValue}
                        toggleView={this.toggleView}
                        splitView={splitView}
                    />}
                    {extraMarkup && extraMarkup()}
                    {splitView ?
                        <Grid container spacing={1}>
                            {LocalizationConfig.locales.map((item) => [
                                <Grid item sm={6}>
                                    <Typography color='textSecondary'>{item.name}</Typography>
                                    <Editor
                                        placeholder={placeholder}
                                        editorState={editorState[item.code]}
                                        toolbarClassName=""
                                        spellCheck={true}
                                        editorClassName={disabled && 'noborder nopadding'}
                                        onEditorStateChange={this.onLocalizedEditorStateChange(item.code)}
                                        readOnly={disabled}
                                        toolbarHidden={disabled}
                                        toolbar={{
                                            image: { uploadCallback: this.onUploadImage }
                                        }}
                                    />
                                </Grid>
                            ])}
                        </Grid>
                        :
                        <Editor
                            placeholder={placeholder}
                            editorState={localize ? editorState[currentLocale] : editorState}
                            toolbarClassName=""
                            spellCheck={true}
                            editorClassName={disabled && 'noborder nopadding'}
                            onEditorStateChange={this.onEditorStateChange}
                            readOnly={disabled}
                            toolbarHidden={disabled}
                            toolbar={{
                                image: { uploadCallback: this.onUploadImage }
                            }}
                        />
                    }
                </FormControl>
            </Grid>
        );
    }
}
